const assets = [
  {
    name: 'displace',
    url: '/static/texture/displace.png',
  }, {
    name: 'noise',
    url: '/static/texture/noise.mp4',
  }, {
    name: 'maskMid',
    url: '/static/texture/mask_mid.png',
  }, {
    name: 'maskWide',
    url: '/static/texture/mask_wide.png',
  }, {
    name: 'maskSmall',
    url: '/static/texture/mask_small.png',
  }, {
    name: 'lightNoise',
    url: '/static/texture/light_noise2.png',
  }, {
    name: 'videoMain',
    url: '/static/video/main.mp4',
  }, {
    name: 'videoSecond',
    url: '/static/video/second.mp4',
  }, {
    name: 'videoThird',
    url: '/static/video/third.mp4',
  }, {
    name: 'videoFourth',
    url: '/static/video/fourth.mp4',
  }, {
    name: 'productOne',
    url: '/static/images/look_book/product_one.jpg',
  }, {
    name: 'productTwo',
    url: '/static/images/look_book/product_two.jpg',
  }, {
    name: 'productThree',
    url: '/static/images/look_book/product_three.jpg',
  }, {
    name: 'productFour',
    url: '/static/images/look_book/product_four.jpg',
  }, {
    name: 'productFive',
    url: '/static/images/look_book/product_five.jpg',
  }, {
    name: 'estateOne',
    url: '/static/images/real_estate/estate1.jpg',
  }, {
    name: 'estateTwo',
    url: '/static/images/real_estate/estate2.jpg',
  }, {
    name: 'estateThree',
    url: '/static/images/real_estate/estate3.jpg',
  }, {
    name: 'estateFour',
    url: '/static/images/real_estate/estate4.jpg',
  }, {
    name: 'estateFive',
    url: '/static/images/real_estate/estate5.jpg',
  }, {
    name: 'estateSix',
    url: '/static/images/real_estate/estate6.jpg',
  }, {
    name: 'estateSeven',
    url: '/static/images/real_estate/estate7.jpg',
  },
  // {
  // name: 'estateEight',
  // url: '/static/images/real_estate/estate8.jpg',
  // },
  {
    name: 'estateNine',
    url: '/static/images/real_estate/estate9.jpg',
  },
];

export default assets;
